module.exports = __webpack_public_path__ + "media/newstyle/images/icon-external-6e2e3cdbdfae697df363e49516b9d42d.svg";